/**
 * Адаптер для преобразования даты и времени "из" и "в" формат для API.
 * @type {{toDate(*): *, toTime(*): *}}
 */
const ApiDateTimeAdapter = {
  toDate(dateTime) {
    return dateTime.split(' ')[0] || null;
  },
  toTime(dateTime) {
    return dateTime.split(' ')[1] || null;
  },
};

export {ApiDateTimeAdapter};